import React, { Component } from 'react';
import { Clearfix, FormGroup, FormControl, ControlLabel, HelpBlock } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Validation } from '../../helper';
import { toast } from 'react-toastify';
//import Button from '@material-ui/core/Button';

const view = Object.freeze({ "requestForm": 0, "okResponseView": 1 });

export default class ForgotPassword extends Component {
    displayName = ForgotPassword.name;
    constructor(props) {
        super(props);

        this.state = {
            submitEnabled: true,
            view: view.requestForm
        };
    }

    onSubmit = async (e) => {
        e.preventDefault();

        this.setState({ ...this.state, submitEnabled: false });
        const data = {
            'email': this.email.value
        };

        this.clearValidationState();

        toast.warn("Processing reset request...", { autoClose: 50000, hideProgressBar: false, position: 'bottom-right' });
        let response = await fetch("/api/login/requestpasswordreset", {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        toast.dismiss();
        if (response.ok) {
            this.setState({ ...this.state, view: view.okResponseView });
        }
        else {
            let errorResult = await response.json();
            this.setState({ ...this.state, errorResult: errorResult, submitEnabled: true });
            if (errorResult.errorSummary) {
                toast.error(errorResult.errorSummary);
                if (errorResult.errors.length > 0) {
                    for (let err of errorResult.errors) {
                        console.log(err.errorMessage);
                    }
                }
            }
        }
    }

    // Watch out for timing issues with this
    clearValidationState = () => {
        try {
            // Apparently Edge doesn't create Symbol.iterator for node lists
            // so we cannot use for-let-of, and instead must convert nodelist to an array
            let hasErrors = document.getElementsByClassName('has-error');
            if (hasErrors && hasErrors.length > 0) {
                let arrayOfErrors = Array.from(hasErrors);
                for (let i = 0; i < arrayOfErrors.length; i++) {
                    arrayOfErrors[i].classList.remove('has-error');
                }
            }
            let helpBlocks = document.getElementsByClassName('help-block');
            if (helpBlocks && helpBlocks.length > 0) {
                let arrayOfHelpBlocks = Array.from(helpBlocks);
                for (let i = 0; i < arrayOfHelpBlocks.length; i++) {
                    arrayOfHelpBlocks[i].textContent = '';
                }
            }
        }
        catch (error) {
            console.log('Error clearing validations'); console.log(error);
        }

        toast.dismiss();
        this.setState({ errorResult: undefined });
    }

    renderRequestForm() {
        return (
            <div>
                <div className="text-center" style={{ paddingBottom: '35px', maxWidth: '40em', margin: 'auto' }}>
                    <div style={{ marginTop: '1em' }}>
                        <strong>Reset your Password</strong>
                    </div>
                    <div style={{ marginTop: '1em' }}>
                        If you have an email on file with us, we'll send you details on how to update your password. Note that the message may be redirected to your Junk folder.
                    </div>
                </div>
                <form onSubmit={this.onSubmit.bind(this)} style={{ maxWidth: '25em', margin: 'auto' }}>
                    <FormGroup controlId="email" validationState={Validation.getFieldValidationState("email", this.state.errorResult)}>
                        <ControlLabel>Email</ControlLabel>
                        <FormControl componentClass="input" type="text" name="email" placeholder="Email" inputRef={(ref) => this.email = ref} />
                        <HelpBlock>{Validation.getFieldValidationText("email", this.state.errorResult)}</HelpBlock>
                    </FormGroup>
                    <Clearfix />
                    <div className="text-center">
                        <button className="btn-block" type="submit" ref={(ref) => this.submitButton = ref}
                            disabled={!this.state.submitEnabled}
                        >SUBMIT</button>
                    </div>
                </form>
            </div>

        );
    }

    renderOkResponseView() {
        return (
            <div className="text-center" style={{ paddingBottom: '35px', maxWidth: '30em', margin: 'auto', marginTop: '1em' }}>

                <div style={{ marginTop: '1em' }}>
                    <strong>Your request has been submitted.</strong>
                </div>
                <div style={{ marginTop: '1em' }}>
                    If your account is on file, you will receive an email with details to reset your password.
                </div>
                <div style={{ marginTop: '2em' }}>
                    <Link to="/login" className="plain-link">Return to Login</Link>
                </div>

            </div>
        );
    }

    render() {
        return (
            <div style={{ paddingBottom: '25px' }}>
                {this.state.view === view.requestForm && this.renderRequestForm()}
                {this.state.view === view.okResponseView && this.renderOkResponseView()}
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/components/Login/ForgotPassword.js